
<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>تعریف/ویرایش قالب پیام</v-card-subtitle>
        <v-spacer/>
        <v-card-text>


          <v-form ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>
              <v-col cols="12" sm="3">
                <v-autocomplete
                    :items="buildingList"
                    v-model="model.buildingId"
                    dense
                    outlined
                    :error-messages="getError('buildingId')"
                    auto-select-first append-icon="fas fa-angle-down"
                    label="انتخاب مجتمع"

                />
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                    :items="subjectItems"
                    v-model="model.subject"
                    dense
                    outlined
                    :error-messages="getError('subject')"
                    auto-select-first append-icon="fas fa-angle-down"
                    label="انتخاب موضوع"

                />
              </v-col>
              <v-col
                  cols="12"
                  sm="3">

                <v-text-field
                    label="نام قالب به انگلیسی"
                    outlined
                    dense
                    :error-messages="getError('templateEn')"
                    v-model="model.templateEn"
                />

              </v-col>
              <v-col
                  cols="12"
                  sm="3"
              >

                <v-text-field
                    label="نام قالب به فارسی"
                    outlined
                    dense
                    :error-messages="getError('templateFa')"
                    v-model="model.templateFa"
                />

              </v-col>
              <v-col
                  cols="12"
                  sm="12"
              >
              <v-alert
                  dense
                  type="info"
                  border="right"
                  color="warning "
                  elevation="1"
                  class="mb-4"
              >
                 ستون اول در فایل اکسل برای تعریف شماره موبایل می باشد و در شماره گذاری  لحاظ نمی شود.
              </v-alert>
              </v-col>
              <v-col cols="12">
                <div v-if="model.subject!=='Alert'">
                  <v-card-text>
                    <v-row>
                      <v-col
                          cols="12"
                          sm="2"
                          v-for="i in 6 "
                          :key="i"
                      >
                        <v-btn
                            block
                            :disabled=" model.message.includes('#' + (i)+'#')"
                            small
                            depressed
                            color="info"
                            class=" p-1 m-1"
                            @click="appendSms(i)"
                        >
                          ستون {{ i }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>

                </div>
                <div v-else>
                  <v-card-text>
                    <v-row>
                      <v-col
                          cols="12"
                          md="2"
                          v-for="(item,i) in fieldItems "
                          :key="i"
                      >
                        <v-btn
                            block
                            :disabled=" model.message.includes(item.number)"
                            small
                            depressed
                            color="info"
                            class=" p-1 m-1"
                            @click="appendSms2(item.number)"
                        >
                          {{item.text}}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>


                </div>
              </v-col>

              <v-col
                  cols="12"
                  sm="12"
              >

                <v-textarea
                    label="متن پیام"
                    outlined
                    dense
                    :error-messages="getError('message')"
                    v-model="model.message"
                />
                <span  style="float: left!important;font-size: 14px!important;" class="text-caption black--text">
                  تعداد کاراکتر: {{ messageStats.length }} |
                  تعداد پیامک: {{ messageStats.smsCount }}
                </span>
              </v-col>
              <v-col
                  cols="12"
                  sm="12"
                  v-if="model.status==='NotConfirmed'"
              >

                <v-textarea
                    :rows="1"
                    label="توضیحات"
                    outlined
                    dense
                    v-model="model.descripiton"
                />

              </v-col>
            </v-row>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="primary"
                  class=" pr-1 pl-1"
                  type="submit"
                  :loading="loading"
              >
                ثبت و ارسال
              </v-btn>
              <v-btn
                  small
                  depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Servise_se from "./Servise_se.js";


export default {

  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,
    buildingList:Array,
    subjectItems:Array,
  },
  data() {
    return {
      count: 1,
      bindingErrors: [],
      loading: false,
      valid: true,
      fieldItems: [
        {value: 'unitName', text: 'نام واحد',number:'#1#'},
        {value: 'ownerName', text: 'نام مالک',number:'#2#'},
        {value: 'tenantName', text: 'نام مستاجر',number:'#3#'},
        {value: 'remainingDebtor', text: 'مانده بدهکار',number:'#4#'},
        {value: 'date', text: 'تاریخ',number:'#5#'},
      ],
    }
  },


  methods: {
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    closed() {
      this.bindingErrors = []
      this.loading = false
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('TemplateSmsManager')


    },
    appendSms(i) {
      this.model.countCell=1
      if (!this.model.message) {
        this.model.message = '';
      }
      this.model.message += ` #${i}#`;


    },
    appendSms2(num) {
      if (!this.model.message) {
        this.model.message = '';
      }
      this.model.message += num;


    },


    save() {
      this.loading = true
      this.bindingErrors = []
      this.model.countCell+=this.maxSelectedColumn
// alert(  this.model.countCell)
      Servise_se.save(this.model).then(response => {
        if (response && response.status === 200) {
          this.$snack({type: 'success'})
          this.closed()
        } else if (response && response.response.status === 400) {
          this.loading = false
          this.bindingErrors = response.response.data;
        }
      })

    },

  },
  computed: {
    messageStats() {
      const message = this.model.message || '';
      const length = message.length;
      // تخمین تعداد پیامک بر اساس طول پیام (فرض: فارسی، 70 کاراکتر اول، بعدش 67تایی)
      let smsCount = 0;
      if (length > 0) {
        if (length <= 70) {
          smsCount = 1;
        } else {
          smsCount = Math.ceil((length - 70) / 67) + 1;
        }
      }

      return {
        length,
        smsCount
      };
    },
    maxSelectedColumn() {
      // استخراج تمام عددها بعد از #
      const matches = this.model.message.match(/#(\d+)/g);
      if (!matches) return 0;

      // تبدیل به عدد و یافتن بیشترین مقدار
      const numbers = matches.map(m => parseInt(m.replace('#', '')));
      return  Math.max(...numbers);


    }
  }


}
</script>


